var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAllSitesGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 9.5C1.5 5.36001 4.85999 2 9 2C13.14 2 16.5 5.36001 16.5 9.5C16.5 13.64 13.14 17 9 17C4.85999 17 1.5 13.64 1.5 9.5ZM9 15.5C5.69247 15.5 3 12.8075 3 9.5C3 6.1925 5.69247 3.5 9 3.5C12.3075 3.5 15 6.1925 15 9.5C15 12.8075 12.3075 15.5 9 15.5Z",
  fill: "#A8AFB8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4181 10.9199C9.80511 11.5329 9.32606 12.2549 9 13.0404C8.67393 12.2549 8.19488 11.5329 7.58192 10.9199C6.96808 10.3061 6.24476 9.82641 5.45763 9.5C6.24476 9.17359 6.96808 8.69389 7.58192 8.08005C8.19488 7.46709 8.67393 6.74512 9 5.95957C9.32606 6.74512 9.80511 7.46709 10.4181 8.08005C11.0319 8.69389 11.7552 9.17359 12.5424 9.5C11.7552 9.82641 11.0319 10.3061 10.4181 10.9199Z",
  fill: "#A8AFB8",
  stroke: "#A8AFB8"
})));
export default SvgIconAllSitesGrey;